export enum DepartureReturnButtonState {
  None = 0,
  Departure = 1,
  DepartureCompleted = 2,
  Return = 3,
  ReturnCompleted = 4
}

export enum ButtonDateType {
  Departure,
  Return
}
